import React from "react";

import "./ArticleParagraph.scss"

export interface IArticleParagraph {
  paragraph: string;
}

const ArticleParagraph = (props: IArticleParagraph) => {
  let { paragraph } = props;
  return (
    <div className="m-article-paragraph">
      {paragraph}
    </div>
  );
};

export default ArticleParagraph;
